import script from "./visionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./visionSection.vue?vue&type=script&setup=true&lang=js"

import "./visionSection.vue?vue&type=style&index=0&id=c758d600&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c758d600"]])

export default __exports__